module.exports = __webpack_public_path__ + "static/media/cover.4e47c388.png";